// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__Ond9M","mobile-hide":"styles-m__mobile-hide__1KFc2","line-separater":"styles-m__line-separater__3QY02","skip-line":"styles-m__skip-line__1bNfV"};